var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22,23H0V6.053H7.334V3.631L11,0l3.666,3.631v7.264H22V23Zm-4.888-4.842v2.421h2.444V18.158Zm-7.334,0v2.421h2.444V18.158Zm-7.334,0v2.421H4.888V18.158Zm14.667-4.843v2.421h2.444V13.316Zm-7.334,0v2.421h2.444V13.316Zm-7.334,0v2.421H4.888V13.316ZM9.778,8.474v2.421h2.444V8.474Zm-7.334,0v2.421H4.888V8.474ZM9.778,3.631V6.053h2.444V3.631Z",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCity);
export default __webpack_public_path__ + "static/media/icon-city.e9a60396eaac4903def5a33c2f03b777.svg";
export { ForwardRef as ReactComponent };